module.exports = __webpack_public_path__ + "media/images/emblems/Oberaegeri_Wappen-f390aa997a1158ab49dc2f16a39a2ab1.svg";